export default {
  uniquePageId: {
    categoryPage: 'open_vac',
    cardDetailPage: 'open_cd',
    compareCardsPage: 'open_cc'
  }
};
